<template>
  <v-container fluid>
    <h4 class="mb-2">{{ $t('Perduodami dokumentai') }}</h4>
    <template v-if="checkingSign">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      {{ $t('Tikrinamas bylos parašas') }}
    </template>
    <template v-if="loadingData && !checkingSign">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      {{ $t('Kraunamos bylos') }}
    </template>
    <template v-if="!loadingData && !checkingSign">
      <v-data-table
        :headers="filteredHeaders"
        :items="itemsList"
        :loading="loadingData"
        :footer-props="{
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageText: this.$t('Rodyti po:'),
          itemsPerPageAllText: this.$t('visi'),
          itemsPerPageOptions: itemsPerPageOptions,
        }"
        :hide-default-footer="hideFooter"
        :items-per-page="pageSize"
      >
        <template #[`item.byla`]="{ item }">
          <el-byla :key="item.byl_id" :byla="item" with-name long-name />
        </template>
        <template #[`item.actions`]="{ item }">
          <v-icon v-if="item.byl_pasirasyta" color="green"
            >mdi-checkbox-marked-outline</v-icon
          >
          <v-chip
            color="default"
            small
            outlined
            class="mr-2"
            v-if="!item.reikia_pasirasyti"
          >
            {{ $t('nepasirašoma') }}
          </v-chip>
        </template>
        <template slot="loading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          {{ $t('Generuojamos bylos pasirašymui') }}
        </template>
        <template slot="no-results">
          {{ $t('Duomenų nėra') }}
        </template>
        <template slot="no-data">
          {{ $t('Duomenų nėra') }}
        </template>
        <template #[`footer.page-text`]="props">
          {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
          {{ $t('iš') }}
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalPaieskaAtmetimasBylos',
  props: {
    paiId: Number,
  },
  data() {
    return {
      loading: true,
      checkingSign: false,
      paieskaBylos: [],

      signStatus: {
        pasirasymas: true,
        bylu_generavimas: 1,
      },
      refreshTimer: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      abortLoading: false,
    }
  },
  computed: {
    ...mapGetters(['signType', 'signTransactionID']),
    headers() {
      return [
        {
          text: this.$t('Byla'),
          align: 'start',
          sortable: false,
          value: 'byla',
        },
        {
          text: this.$t('Pasirašyta'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 150,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.paieskaBylos.map(byla => {
        byla.byl_url = `ntrpaslaugos/byla/${byla.byl_id}/${byla.byl_hash}/content`
        byla.obj_dokumento_numeris = byla.byl_dokumento_nr
        byla.pranesimas_numeris = this.paiId
        return byla
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    refreshTimeout() {
      return 1000
    },
    loadingData() {
      return (
        this.signStatus.bylu_generavimas !== 2 &&
        this.signStatus.bylu_generavimas !== 4
      )
    },
    unsignedList() {
      return this.paieskaBylos.filter(item => {
        return item.byl_pasirasyta === false && item.reikia_pasirasyti === true
      })
    },
    needSign() {
      return this.unsignedList.length > 0
    },
  },
  created() {
    this.abortLoading = false
    this.signAuth()
  },
  beforeDestroy() {
    this.abortLoading = true
  },
  methods: {
    getData() {
      this.loading = true
      this.showFail = false
      this.$axios
        .get(`paieska/${this.paiId}/atmesti/bylos`)
        .then(res => {
          this.signStatus = res.data.status
          if (!this.loadingData) {
            this.paieskaBylos = res.data.bylos
          }
          this.checkLoading()
        })
        .catch(err => {
          if (err.response) {
            window._VMA.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    checkLoading() {
      if (this.loadingData && !this.abortLoading) {
        if (!this.refreshTimer) {
          this.refreshTimer = setInterval(() => {
            if (this.refreshTimer) {
              this.getData()
            }
          }, this.refreshTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
      this.$emit('stopLoading', this.unsignedList)
    },
    signAuth() {
      if (!this.signType || !this.signTransactionID) {
        this.$store.dispatch('signType', null)
        this.$store.dispatch('signTransactionID', null)
        this.getData()
        return
      }
      this.checkingSign = true

      const signData = {
        signType: this.signType,
        transactionID: this.signTransactionID,
      }

      this.$axios
        .post(`paieska/${this.paiId}/pasirasymas/tikrinti`, signData)
        .then(res => {
          this.$store.dispatch('signTransactionID', null)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.checkingSign = false
          this.getData()
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
